import PopoverTemplate from '@nkr/components/popover-template';
import { Utility } from '@nkr/services/utility';
import styled from 'styled-components';

// react-bootstrap positions the popover with inline top/left, so !important is
// required to center it instead. The arrow is hidden because it no longer points
// at the trigger.
const CenteredPopover = styled(PopoverTemplate)`
    position: fixed !important;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%);
    margin: 0;

    > .arrow {
        display: none;
    }
`;

const Info = (props: { lvPercentile: number, nvPercentile: number }) => {
    const lvPercentileSuffix = Utility.getOrdinalSuffixOf(parseInt(props.lvPercentile.toString()), false);
    const nvPercentileSuffix = Utility.getOrdinalSuffixOf(parseInt(props.nvPercentile.toString()), false);

    return (
        <CenteredPopover title='Report Information'>
            <div>
                Add up the following "Percentile in Network" numbers to determine centers overall ranking. The center with the lowest number will be first and the center
                with the highest number will be last.
            </div>
            <ol>
                <li>Swap Failure Rate Last 12 Months</li>
                <li>Virtual Crossmatch Accuracy Last 12 Months</li>
                <li>Chain End Decline Ratio Last 12 Months</li>
                <li>NKR Donor Referral Conversion Rate</li>
                <li>NKR Transplants Last 12 Months</li>
            </ol>

            <div>NOTE: Still show as LV or NV where applicable but use the default percentiles below to determine overall rankings.</div>
            <ul>
                <li>Low Volume = {props.lvPercentile}<sup>{lvPercentileSuffix}</sup> percentile</li>
                <li>No Volume = {props.nvPercentile}<sup>{nvPercentileSuffix}</sup> percentile</li>
            </ul>
        </CenteredPopover>
    );
}

export default Info;